import React from "react";
import { toElementProps } from "../../Element";

export function LinkStyles(params = {}) {
    return {
        "& .link": {},
    };
}

export default function Link(props) {
    const spread = {};
    spread.href = props.href;
    props.target && (spread.target = props.target);

    const elProps = toElementProps(props, { className: ["link"] });
    return (
        <a {...elProps} {...spread}>
            {props.text || props.children}
        </a>
    );
}
